import {
  GET_DATA_RETENTION_SETTINGS,
  GET_DATA_RETENTION_SETTINGS_SUCCESS,
  GET_DATA_RETENTION_SETTINGS_ERROR,
} from './actionTypes';

const initialState = {
  errorGetDataRetentionSettings: '',
  loadingGetDataRetentionSettings: false,
  dataRetentionSettings: null,
};

const getDataRetentionSettings = (state = initialState, action) => {
  switch (action.type) {
    case GET_DATA_RETENTION_SETTINGS:
      state = { ...state, loadingGetDataRetentionSettings: true };
      break;
    case GET_DATA_RETENTION_SETTINGS_SUCCESS:
      state = {
        ...state,
        loadingGetDataRetentionSettings: false,
        dataRetentionSettings: action.payload.settings,
      };
      break;
    case GET_DATA_RETENTION_SETTINGS_ERROR:
      state = { ...state, errorGetDataRetentionSettings: action.payload, loadingGetDataRetentionSettings: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getDataRetentionSettings;
